import { PRODUCTS_AND_SERVICES_BACKEND_API_URL } from 'services/constants';
import axios from 'axios';

/**
 * Get owner of case in PCO
 * @param caseId The id of the case
 */
export const getCaseOwner = async (caseId: string) => {
  const json = await axios.get(`${PRODUCTS_AND_SERVICES_BACKEND_API_URL}/api/v1/productservices/case/${caseId}/owner`);
  return json.data;
};
